import { render, staticRenderFns } from "./CrmLeadDetailHistoryUi.vue?vue&type=template&id=487ae382&scoped=true&lang=pug&"
import script from "./CrmLeadDetailHistoryUi.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailHistoryUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadDetailHistoryUi.vue?vue&type=style&index=0&id=487ae382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487ae382",
  null
  
)

export default component.exports